import apiRequest from "@/services/apiRequest";

export default {
  namespaced: true,
  state: {
    videos: [],
    play: null
  },
  getters: {},
  mutations: {
    setVideos(state, payload) {
      payload.forEach((video, index) => {
        //definig temp id because currently this data is not being returned from the server
        video.temp_video_id = index + 1; //in order for the temp_video_id to be base 1 (instead of base 0) - according to the backend developer request
      });
      state.videos = payload;
    },
    setPlay(state, video) {
      state.play = video;
    },
    cancelPlay(state) {
      state.play = null;
    }
  },
  actions: {
    async getVideos({ commit, rootState, rootGetters }) {
      commit("incrementPendingApiCallsCount", null, { root: true });

      let requestLang;
      if (["de", "it", "es", "pt"].includes(rootState.lang)) {
        requestLang = "en";
      } else {
        requestLang = rootState.lang;
      }
      let response = await apiRequest.get(
        rootGetters.baseApiUrl("webtv/get/") + "webtv/get/" + requestLang
      );
      let data = response.data;
      if (data) {
        commit("setVideos", data);
        commit("decrementPendingApiCallsCount", null, { root: true });
      } else {
        console.log(response);
      }
    },

    play({ commit }, video) {
      commit("setPlay", video);
    },

    cancelPlay({ commit }) {
      commit("cancelPlay");
    }
  }
};
